export default {"src":"/_next/static/media/dash.88b38181.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};